module.exports = __webpack_public_path__ + "static/img/cloud.faf6895.jpeg";